export default "__VITE_ASSET__DA6p_Ieb__"